import { Link } from 'react-router-dom';
import { getRecentArticles } from '@/mocks/articles';

export default function RecentArticles() {
  const recentArticles = getRecentArticles(6);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              最新文章
            </h2>
            <p className="text-foreground-600 text-sm">
              持续更新的火影同人创作内容
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {recentArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-100 rounded-xl overflow-hidden cursor-pointer transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <span className="text-xs text-primary-600 font-medium bg-primary-50 px-2 py-0.5 rounded whitespace-nowrap">
                  {article.categoryName}
                </span>
                <h3 className="font-heading text-base font-bold text-foreground-950 mt-2 mb-1.5 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}